import { MIXPANEL_EVENTS } from '../utils/mixpanel-consts';
import { track } from '../utils/mixpanel-helper';

interface EmailSupportLinkProps {
  className?: string;
}

const EmailSupportLink = ({
  className,
}: EmailSupportLinkProps): JSX.Element => {
  const address = 'support@pivot.co';
  return (
    <a
      href={`mailto:${address}`}
      onClick={() => {
        track(MIXPANEL_EVENTS.EMAIL_SUPPORT_LINK, {
          'Page Path': window.location.pathname,
        });
      }}
      className={className}
    >
      {address}
    </a>
  );
};

export default EmailSupportLink;
